import { version } from "src/version";

export class Version {
    public major: number;
    public minor: number;
    public patch: number;
    public revision: number;

    isCriticalUpdate(): boolean {
        let current = Version.parse(version);
        return this.major > current.major
            || this.major === current.major && this.minor > current.minor;
    }

    isMinorUpdate(): boolean {
        let current = Version.parse(version);
        return this.major === current.major
            && this.minor === current.minor
            && this.patch > current.patch;
    }

    static parse(input: string): Version {
        let tokens = input.split('.');
        let version = new Version();
        version.major = +tokens[0];
        version.minor = +tokens[1];
        version.patch = +tokens[2];
        version.revision = +tokens[3];
        return version;
    }
}
